import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { useSession } from "@/context/SessionContext";

export const STEPS = [
  { path: "/project", label: "Project" },
  { path: "/styles", label: "Styles" },
  { path: "/palette", label: "Palette" },
  { path: "/about", label: "About you" },
  { path: "/furniture", label: "Furniture" },
  { path: "/board", label: "Board" },
];

export function ProgressBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { session } = useSession();
  const idx = Math.max(0, STEPS.findIndex((s) => s.path === pathname));
  const pct = ((idx + 1) / STEPS.length) * 100;
  const count = session?.taste_list?.length || 0;

  return (
    <header data-testid="progress-header" className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-neutral-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" data-testid="header-logo" className="font-display text-2xl tracking-wide">interiorsmoodboard</Link>
        <nav className="hidden md:flex items-center gap-6">
          {STEPS.map((s, i) => (
            <button
              key={s.path}
              data-testid={`step-${s.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => i <= (session?.step ?? 0) && navigate(s.path)}
              className={`text-xs tracking-[0.18em] uppercase transition-colors ${i === idx ? "text-neutral-900 font-semibold" : i <= (session?.step ?? 0) ? "text-neutral-500 hover:text-neutral-900" : "text-neutral-300 cursor-default"}`}
            >
              {s.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="open-board-button"
          onClick={() => navigate("/board")}
          className="relative inline-flex items-center gap-2 rounded-full border border-neutral-300 h-10 px-4 text-sm hover:border-neutral-900 transition-colors"
        >
          <LayoutGrid size={15} />
          <span className="hidden sm:inline">My board</span>
          {count > 0 && (
            <span data-testid="taste-count-badge" className="absolute -top-1.5 -right-1.5 h-5 min-w-5 px-1.5 rounded-full bg-neutral-900 text-white text-[10px] flex items-center justify-center">
              {count}
            </span>
          )}
        </button>
      </div>
      <div className="h-[2px] bg-neutral-100">
        <div data-testid="progress-fill" className="h-full bg-neutral-900 transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
      </div>
      <p className="md:hidden text-center text-[10px] tracking-[0.2em] uppercase text-neutral-400 py-1.5">
        Step {idx + 1} of {STEPS.length} · {STEPS[idx].label}
      </p>
    </header>
  );
}
